import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=a410111c&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=ts&"
export * from "./Categories.vue?vue&type=script&lang=ts&"
import style0 from "./Categories.vue?vue&type=style&index=0&id=a410111c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a410111c",
  null
  
)

export default component.exports